export default (theme) => ({
    link: {
        display: "flex",
        color: "black",
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    separator: {
        color: "black",
    },
});
